import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="key-features-toggle"
// Synchronizes expand/collapse state of Key Inclusions across all provider cards
export default class extends Controller {
  static targets = ["details"];

  connect() {
    this.syncing = false;
  }

  toggle(event) {
    if (this.syncing) return;

    this.syncing = true;
    const isOpen = event.target.open;

    // Sync all key features details elements to the same state
    this.detailsTargets.forEach((details) => {
      details.open = isOpen;
    });

    this.syncing = false;
  }
}
